import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Layers, MessageSquare, MapPin, CheckSquare } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    text: '¿Por qué sacaron esa foto?',
    author: 'Nadie entendía el contexto'
  }, {
    text: 'Pasé 3 horas armando el informe semanal.',
    author: 'Constructor'
  }];
  const blocks = [{
    icon: <Layers className="w-5 h-5 text-blue-600" data-id="element-208" />,
    title: 'Contexto',
    text: 'Qué se estaba viendo.'
  }, {
    icon: <MessageSquare className="w-5 h-5 text-blue-600" data-id="element-209" />,
    title: 'Conversación',
    text: 'Qué se dijo antes y después.'
  }, {
    icon: <MapPin className="w-5 h-5 text-blue-600" data-id="element-210" />,
    title: 'Ubicación',
    text: 'Dónde ocurrió.'
  }, {
    icon: <CheckSquare className="w-5 h-5 text-blue-600" data-id="element-211" />,
    title: 'Decisión',
    text: 'Qué se resolvió.'
  }];
  return <section id="problema" className="scroll-mt-20 py-16 sm:py-24 bg-white" data-id="element-212">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 sm:mb-16" data-id="element-214">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4
        }} className="inline-block px-4 py-1.5 bg-blue-50 text-blue-600 text-xs font-bold uppercase tracking-wider rounded-full mb-6" data-id="element-215">
            EL PROBLEMA
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-[28px] sm:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-5 sm:mb-6 leading-[1.1] tracking-tight" data-id="element-216">
            Una foto sola{' '}
            <span className="text-blue-600" data-id="element-217">no explica una obra.</span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="text-base sm:text-lg lg:text-xl text-gray-600 leading-relaxed" data-id="element-218">
            Lo importante no es la foto.
            <span className="block" data-id="element-219">
              Es entender qué estaba pasando cuando se tomó.
            </span>
          </motion.p>
        </div>

        {/* Two-column layout */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-start" data-id="element-220">
          {/* Left: testimonial cards */}
          <div className="space-y-4 sm:space-y-5" data-id="element-221">
            {problems.map((problem, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1 + index * 0.1
          }} className="relative bg-gray-50 border border-gray-200 rounded-2xl p-6 sm:p-8" data-id="element-222">
                <Quote className="w-5 h-5 sm:w-6 sm:h-6 text-blue-300 mb-3" data-id="element-223" />
                <p className="text-lg sm:text-xl text-gray-900 font-medium leading-snug mb-4 sm:mb-5" data-id="element-224">
                  "{problem.text}"
                </p>
                <p className="text-[11px] sm:text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-225">
                  — {problem.author}
                </p>
              </motion.div>)}
          </div>

          {/* Right: 4 context blocks */}
          <div className="grid grid-cols-2 gap-3 sm:gap-4" data-id="element-226">
            {blocks.map((block, index) => <motion.div key={block.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.15 + index * 0.06
          }} className="bg-white border border-gray-200 rounded-2xl p-5 sm:p-6" data-id="element-227">
                <div className="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center mb-4" data-id="element-228">
                  {block.icon}
                </div>
                <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-1.5" data-id="element-229">
                  {block.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-230">
                  {block.text}
                </p>
              </motion.div>)}
          </div>
        </div>

        {/* Closing sentence */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center text-xl sm:text-2xl lg:text-3xl font-extrabold text-gray-900 leading-tight tracking-tight max-w-3xl mx-auto mt-16 sm:mt-20" data-id="element-231">
          Cualquiera puede guardar fotos.
          <span className="block text-blue-600 mt-2" data-id="element-232">
            El problema es guardar la historia detrás de ellas.
          </span>
        </motion.p>
      </div>
    </section>;
}